export const TRANSPORT_PAGES = {
  ACTION_REQUIRED_TRANSPORTS: "ActionsRequiredTransports",
  AREA_ARRIVED_TRANSPORTS: "AreaArrivedTransports",
  DEPARTED_TRANSPORTS: "DepartedTransports",
  NO_DEPARTURE_FROM_DESTINATION_TRANSPORTS: "NoDepartureFromDestinationTransports",
  ONGOING_ARRIVED_TRANSPORTS: "OngoingArrivedTransports",
  CANCELLED_TRANSPORTS: "CancelledTransports",
  COMPLETED_TRANSPORTS: "CompletedTransports",
  GPS_LOST_TRANSPORTS: "GpsLostTransports",
  GPS_LOW_TRANSPORTS: "GpsLowTransports",
  WAYPOINT_CONFIRMATION_TRANSPORTS: "WaypointConfirmationTransports",
  GPS_MISSING_TRANSPORTS: "GpsMissingTransports",
  INCOMING_TRANSPORTS: "IncomingTransports",
  MANUALLY_COMPLETED_TRANSPORTS: "ManuallyCompletedTransports",
  ONGOING_TRANSPORTS: "OngoingTransports",
  OVERDUE_TRANSPORTS: "OverdueTransports",
  PLANNED_TRANSPORTS: "PlannedTransports",
  PRESUMABLY_INCOMING_TRANSPORTS: "PresumablyIncomingTransports",
  PRESUMABLY_ONGOING_TRANSPORTS: "PresumablyOngoingTransports",
  SEARCH_RESULTS: "SearchResults",
  TRACKING_ID_MISSING_TRANSPORTS: "TrackingIdMissingTransports",
  LOCATION_ARRIVAL_TRANSPORTS: "LocationArrivalTransports",
  WATCHLIST: "Watchlist",
};

export const PAGES = {
  ...TRANSPORT_PAGES,
  ADMIN_TRANSPORT_CSV_IMPORT: "AdminTransportCsvImport",
  LIVE_MAP: "LiveMap",
  NOT_AUTHORIZED: "NotAuthorized",
  NOT_FOUND: "NotFound",
  NOTIFICATIONS_SETTINGS: "NotificationsSettings",
  OUTDATED_TRANSPORT: "OutdatedTransport",
  TRANSPORT_DETAILS: "TransportDetails",
  TRANSPORT_TRACKING: "TransportWaypointTracking",
  WAYPOINT_DETAILS: "WaypointDetails",
  SERVER_ERROR: "ServerError",
  FAQ: "FAQ",
  COCKPIT: "Cockpit",
};
